import React, { useEffect, useState } from 'react';
import { useForm, SubmitHandler } from 'react-hook-form';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { toast } from 'react-hot-toast';
import { getInvoiceById, updateInvoice, UpdateInvoiceData } from '../../../services/invoiceService';
import { Invoice } from '../../../types/invoice';
import { InvoiceStatus } from '../../../types/enums';
import formStyles from '../trainees/TraineeForm.module.css';

type FormInputs = Required<UpdateInvoiceData>;

const EditInvoicePage: React.FC = () => {
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();
  const invoiceId = Number(id);
  const [invoice, setInvoice] = useState<Invoice | null>(null);
  const { register, handleSubmit, reset, formState: { isSubmitting } } = useForm<FormInputs>();

  useEffect(() => {
    if (!invoiceId) return;
    getInvoiceById(invoiceId)
      .then(data => {
        setInvoice(data);
        reset({
          ...data,
          due_date: data.due_date.split('T')[0],
          payment_date: data.payment_date ? data.payment_date.split('T')[0] : null,
        });
      })
      .catch(() => {
        toast.error('فشل في جلب بيانات الفاتورة.');
        navigate('/admin/invoices/list');
      });
  }, [invoiceId, navigate, reset]);

  const onSubmit: SubmitHandler<FormInputs> = (data) => {
    const promise = updateInvoice(invoiceId, data);
    toast.promise(promise, {
      loading: 'جاري تحديث الفاتورة...',
      success: () => {
        navigate('/admin/invoices/list');
        return 'تم تحديث الفاتورة بنجاح!';
      },
      error: (err) => err.response?.data?.message || 'فشل في تحديث البيانات.',
    });
  };

  if (!invoice) return <div>جاري التحميل...</div>;

  return (
    <div className={formStyles.pageContainer}>
      <div className={formStyles.formContainer}>
        <h2 className={formStyles.title}>تعديل الفاتورة رقم: {invoice.id}</h2>
        <form onSubmit={handleSubmit(onSubmit)} className={formStyles.form}>
          <div className={formStyles.formField}>
            <label htmlFor="status">الحالة</label>
            <select id="status" {...register('status')} className={formStyles.input}>
              {Object.values(InvoiceStatus).map(s => <option key={s} value={s}>{s}</option>)}
            </select>
          </div>
          <div className={formStyles.formField}>
            <label htmlFor="amount">المبلغ</label>
            <input id="amount" type="number" step="0.01" {...register('amount', { required: true, valueAsNumber: true })} className={formStyles.input} />
          </div>
          <div className={formStyles.formField}>
            <label htmlFor="due_date">تاريخ الاستحقاق</label>
            <input id="due_date" type="date" {...register('due_date', { required: true })} className={formStyles.input} />
          </div>
          <div className={formStyles.formField}>
            <label htmlFor="payment_date">تاريخ الدفع</label>
            <input id="payment_date" type="date" {...register('payment_date')} className={formStyles.input} />
          </div>
          <div className={`${formStyles.buttonContainer} ${formStyles.fullWidth}`}>
            <Link to="/admin/invoices/list" className={formStyles.cancelButton}>العودة للقائمة</Link>
            <button type="submit" disabled={isSubmitting} className={formStyles.submitButton}>
              {isSubmitting ? 'جاري الحفظ...' : 'حفظ التعديلات'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default EditInvoicePage;
